import { StudiosSection } from "../components/BrandSections";
import CTABand from "../components/CTABand";

export default function StudiosPage() {
  return (
    <main className="pt-[72px]" data-testid="studios-page">
      <StudiosSection />
      <CTABand title="Stream broadcast-ready." sub="Hire the studio, dial in your tech, or launch your whole channel with the Incubator." />
    </main>
  );
}
